import { makeStyles } from '@material-ui/styles'
// import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      minWidth: 'max-content',
    },
  },
  form: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: spacing(16),
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(24, '!important'),
    width: 'max-content',
    overflowX: 'unset',
  },
  dynamicButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(20),
    padding: spacing(0, 20),
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  link: {
    textDecorationLine: 'underline',
    color: '#1671ED',

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
  },
  labelWithHelpIcon: {
    color: palette.gray[64],
    fontSize: spacing(16),
    width: 'max-content',
    display: 'flex',
    gap: '4px',
  },
  label: {
    color: palette.gray[64],
    fontSize: spacing(16),
  },
  panelUrlContainer: {
    marginTop: spacing(20),
  },
  horizontalToggler: {
    flex: 1,
    display: 'flex',
    gap: '4px',
    alignItems: 'self-start',
  },
}))
